module.exports = __webpack_public_path__ + "node_modules/ckeditor/contents.css";